import { AlkLogger, debounce } from '@alk/core';
import { APP_CONFIG, loadEnv, OFX_CONFIG } from '../helpers/app-config';
import { init as initModules } from '../services/config.ioc';

const ACTIVITY_DEBOUNCE_TIME = 60_000;

export async function initApp(): Promise<void> {

    await loadEnv();

    initModules();

    AlkLogger.debug('[APP] initApp loadEnv finished.');

    AlkLogger.info(
        `%c${ APP_CONFIG.APP_NAME }@${ APP_CONFIG.VERSION }`,
        'background: black; color: violet; padding: 1px 5px;',
    );

    if (Boolean(OFX_CONFIG.PORTAL_URL)) {
        window.self.addEventListener('click', debounce(callHome(OFX_CONFIG.PORTAL_URL), ACTIVITY_DEBOUNCE_TIME));
    }
}

const callHome = (parentUrl: string) => (): void  => {
    window.top.postMessage('message', parentUrl);
};
